module.exports = {
  async getPlaceBuildings(placeId) {
    const url = `${this.url}/${this.version}/places/${placeId}/buildings`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/place_building_api.js